<template>
    <div>
        <div v-if="form">
            <form-view :form.sync="form" :options.sync="options"></form-view>
        </div>
    </div>
</template>

<script type="text/javascript">
    const { simpleCache } = require('sci/helpers')
    const FormView = require('./WidgetView.vue')

    export default {
        components: {
            FormView
        },
        data () {
            return {
                options: {
                    statuses: []
                }
            }
        },
        props: {
            form: {
                type: Object,
                default: null
            }
        },
        ready () {
            simpleCache('forms.options')
                .then(({ data }) => {
                    this.options = data
                })
        }
    }
</script>



// WEBPACK FOOTER //
// Widget.vue?9a0fc6b6